import { Box } from '@mui/system';

export function Loader({ size = 'small', color = 'white', hasFullWidth = false }) {
    const sizes = {
        small: 16,
        medium: 24,
        large: 32,
    };

    const widths = {
        small: 2,
        medium: 3,
        large: 4,
    };

    const loader = (
        <Box
            sx={{
                height: sizes[size] || sizes.small,
                width: sizes[size] || sizes.small,
                borderRadius: (sizes[size] || sizes.small) / 2,
                border: `${widths[size] || widths.small}px solid ${color}`,
                borderBottomColor: 'transparent',
                animation: 'spin 1s linear infinite', // Добавить анимацию вращения
                '@keyframes spin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' },
                },
            }}
        />
    );

    if (!hasFullWidth) {
        return loader;
    }

    return (
        <Box sx={{
            width: '100%',
            height: 80,

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {loader}
        </Box>
    )
}
